import { useEffect, useState } from 'react';
import { getWeather } from '../services/api';

/**
 * Game-time weather for a list of fixtures, keyed by match_id.
 *
 * Asks for every fixture that has a venue, past ones included: the server reads
 * forecasts the pipeline recorded rather than calling out to NWS, so a played
 * game can still show what the weather was that day. There is no horizon filter
 * here for that reason — the server returns whatever it has, and a fixture with
 * nothing recorded is simply absent.
 *
 * Shared by Schedule and Team Detail, which both render FixtureCard and both
 * need exactly this.
 */
export default function useGameWeather(games) {
  const [weather, setWeather] = useState({});

  // Reduced to a stable string so the effect doesn't re-run on every render
  // just because the caller built a new array with the same contents.
  const ids = (Array.isArray(games) ? games : [])
    .filter((g) => g.venue)
    .map((g) => g.match_id)
    .filter(Boolean);
  const key = ids.join(',');

  useEffect(() => {
    if (!key) {
      setWeather({});
      return undefined;
    }
    let cancelled = false;
    getWeather(key.split(',')).then((w) => {
      if (!cancelled) setWeather(w || {});
    });
    return () => { cancelled = true; };
  }, [key]);

  return weather;
}
